import { createContext, use } from 'react'

// Outside a provider there is no current site to read again.
const noRefresh = (): Promise<void> => Promise.resolve()

/** Reads the current site again; given by `CurrentSiteProvider`. */
export const CurrentSiteRefreshContext = createContext<() => Promise<void>>(noRefresh)

/**
 * Reads the current site again, so the shell shows its branding as just saved. A page that writes
 * a site calls it after each write that committed, whichever site it was.
 */
export function useRefreshCurrentSite(): () => Promise<void> {
  return use(CurrentSiteRefreshContext)
}
